// Check if URL contains items selected and assign them to selectedItems variable
let urlParams = new URLSearchParams(window.location.search);
let selectedItems = urlParams.get('items')?.split(',');

class Compare extends HTMLElement {
  constructor() {
    super();

    // this.productInfo = this.querySelector('.compare__products-info');
    this.parent = this.closest('.product__selector');
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('span');
    this.productOptions = this.querySelectorAll('.compare__products-list input[type="radio"]');
    this.key = this.dataset.key;

    this.addEventListener('input', this.build.bind(this))
  }

  build(event) {
    this.fetchHTML(event.target);
  }

  fetchHTML(element) {
    let value = element.value;

    // set the selected option in the summary
    this.summary.innerHTML = element.dataset.productTitle;

    // update URL with selected values
    let selectedProducts = '';
    this.parent.querySelectorAll('.compare__item:not(.hidden) summary span').forEach((el) => {
      if(selectedProducts != '' ) selectedProducts += ',';
      selectedProducts += el.innerText.trim();
    });

    if(selectedProducts !== '') {
      window.history.pushState({}, '', location.pathname + '?items=' + selectedProducts);
    }

    // fetch data on selection
    fetch(value + "?view=compare")
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        this.details.removeAttribute('open');

        const page__styles = document.getElementById(`fnb__page-style-${this.key}`);
        const page__sizes = document.getElementById(`fnb__page-size-${this.key}`);
        const benefits = document.getElementById(`fnb__benefits-${this.key}`);
        const plp__card = document.getElementById(`plp-card-${this.key}`);
        const plp__card_2 = document.getElementById(`plp-card-2-${this.key}`);
        
        page__styles.innerHTML = parsedHTML.querySelector('.page__styles').innerHTML;
        page__sizes.innerHTML = parsedHTML.querySelector('.page__sizes').innerHTML;
        benefits.innerHTML = parsedHTML.querySelector('.benefits').innerHTML;
        plp__card.innerHTML = parsedHTML.querySelector('.plp-card').innerHTML;   
        plp__card_2.innerHTML = parsedHTML.querySelector('.plp-card-2').innerHTML;        
      })
      .catch((e) => {
        console.error(e);
      });
  }

  bindEvents() {
    document.addEventListener('click', () => {
      if(this.details.open) {
        this.details.open = false;
      }
    })
  }

  connectedCallback() {
    if (!selectedItems) {
      this.fetchHTML(this.productOptions[this.key]);
    }
    this.bindEvents();
  }
}

customElements.define('compare-container', Compare);

// Check if URL contains items and maintain the last selected compare items on page refresh
if(selectedItems) {
  let compareContainers = document.querySelectorAll('compare-container');
  if (selectedItems.length == 3) {
    const allHiddenColumns = document.querySelectorAll('.compare__item.hidden');
    allHiddenColumns.forEach((el) => el.classList.remove('hidden'));
    document.querySelector('.compare__item:nth-child(3)').classList.remove('hidden');
    document.querySelector('.add-compare-option').remove();
  }

  selectedItems.forEach((item, i) => {
    let thisCompareContainer = compareContainers[i];
    
    thisCompareContainer.querySelectorAll('input[type="radio"]').forEach((el, i) => {
      if(item.trim() === el.dataset.productTitle.trim()) {
        thisCompareContainer.fetchHTML(thisCompareContainer.productOptions[i]);
      }
    });
  });
}